module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_3009.826eb0cb.png";